import { version } from '../../package.json';

export const appversion = version;
